<template>
  <main class="extrato">
      <spinner/>
      <toaster/>
      <header class="frame">
        <div class="cabecalho">
          <h1>Negocie já</h1>
          <router-link :to="{ name: 'Extrato Financeiro' }" class="btn btn-secondary">
            <fa :icon="['far', 'arrow-left-long']" class="icon"/>
            Sair
          </router-link>
        </div>
      </header>
      <section class="main-frame">
        <div class="parametros">
         <table>
          <tbody>
            <tr>
              <td class="fullCell" colspan="2">
                <div>
                  Detalhes
                </div>
                <div>{{ mensalidades.length }} Parcela(s) em aberto</div>
              </td>
                <td class="fullCell text-center">
                  {{ formatMoney(valorTotalOriginalSelecionado) }}
                </td>
                <td class="fullCell text-center">
                  <span class="arrowTag">
                    <fa :icon="['fas', 'chevrons-right']" />
                  </span>
                  {{ formatMoney(formaSelecionada?.valorFinalCobrado) }}
                </td>
                <td class="fullCell" colspan="2">
                  <div>Formas de Pagamento</div>
                  <div>{{ formasPagamento.length }} Opções disponíveis</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex w-100 geral">
          <section class="detalhes">
            <aside class="aside-parcelas">
              <table>
                <tr class="">
                  <th colspan="2">Detalhes</th>
                  <th>Valor <br> Original</th>
                  <th>Vencimento <br> Original</th>
                  <th>Valor <br> Atualizado</th>
                  <th>
                    <input type="checkbox" v-model="selecionarTodos" @change="alternarSelecionarTodos" class="check" checked>
                  </th>
                </tr>
                <tr
                  v-for="(mens, i) in mensalidades"
                  :key="i"
                  class="descricao"
                >
                  <td class="number">
                    <div>{{ String(i + 1).padStart(2, '0') }}</div>
                  </td>
                  <td>{{ mens.descricaoCompleta }}</td>
                  <td>{{ formatMoney(mens.valorOriginal) }}</td>
                  <td>{{ mens.vencimentoOriginal?.split(' ')[0] }}</td>
                  <td>{{ formatMoney(mens.valorCorrigido) }}</td>
                  <td>
                    <input type="checkbox" class="check" v-model="mens.selecionado"/>
                  </td>
                </tr>

              </table>
            </aside>
          </section>
          <section class="pagamento">
            <aside class="aside-pagamento">
              <div class="valores">
                <div>
                  <p>Total Original</p>
                  <h1>{{ formatMoney(valorTotalOriginalSelecionado) }}</h1>
                </div>
                <div class="totalFinal">
                  <p>Total Final</p>
                  <h1>{{ formatMoney(formaSelecionada?.valorFinalCobrado) }}</h1>
                </div>
              </div>
              <div>
                <div class="formas">
                  <div>
                    <p>Formas de Pagamento</p>
                  </div>
                  <div class="number">
                    <div>
                      {{ formasPagamento.length }}
                    </div>
                  </div>
                </div>
                <div class="selecao" @click="toggleOpcoes" style="cursor: pointer;">
                  <header>
                    <div class="headerSelecao">
                      <h5>{{ formaSelecionada.nome }}</h5>
                      <div v-if="formaSelecionada.entrada && formaSelecionada.parcelas">
                        Entrada: {{ formaSelecionada.entrada.cartao.parcelasEntrada }}x de {{ formatMoney(formaSelecionada.entrada.cartao.valorEntrada) }}<br>
                        +
                        {{ formaSelecionada.parcelas.cartao.parcelas }}x de {{ formatMoney(formaSelecionada.parcelas.cartao.valorParcela) }}
                      </div>
                    </div>
                  </header>

                  <section class="detalhes">
                    <aside>
                      <div>{{ formaSelecionada.descricao }}</div>
                      <div>{{ formaSelecionada.detalhes }}</div>
                    </aside>
                    <aside class="valorNegocia">
                      <div><h2>{{ formatMoney(formaSelecionada?.valorFinalCobrado) }}</h2></div>
                      <div class="detalhesIcon">
                        <fa :icon="['fas', 'chevron-up']" />
                        <fa :icon="['fas', 'chevron-down']" />
                      </div>
                    </aside>
                  </section>

                  <div v-if="showOpcoes" class="opcoesPagamento">
                    <div
                      v-for="opcao in formasPagamento"
                      :key="opcao.idNegocieJaFormaPagamento"
                      class="opcaoPagamento"
                      @click="selecionarForma(opcao.idNegocieJaFormaPagamento)"
                    >
                      <header>{{ opcao.nome }}</header>
                      <section class="detalhes">
                        <aside>
                          <div>Política: {{ opcao.nomePoliticaOuCampanha }}</div>
                          <div v-if="opcao.entrada && opcao.parcelas">
                            Entrada: {{ opcao.entrada.cartao.parcelasEntrada }}x de {{ formatMoney(opcao.entrada.cartao.valorEntrada) }}<br>
                            +
                            {{ opcao.parcelas.cartao.parcelas }}x de {{ formatMoney(opcao.parcelas.cartao.valorParcela) }}
                          </div>
                        </aside>
                        <aside class="valorNegocia">
                          <h2>{{ formatMoney(opcao.valorFinalCobrado) }}</h2>
                        </aside>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </aside>
          </section>
        </div>
        <section class="botao">
          <button class="btn btn-primary" @click="openModal(forma)">Negociar</button>
        </section>
      </section>
</main>
  <ModalAcordo
    v-model:step="stepModal"
    :visible="modalVisivel"
    :forma="formaSelecionada"
    @fechar="modalVisivel = false"
    @finalizar="confirmarNegociacao"
/>
</template>

<script>
import DebitosService from '@/services/negocieja.service.js'
import { formatMoney } from '@/services/utils.service.js'
import ModalAcordo from '@/components/financeiro/negocieja/acordo/ModalAcordo.vue'

export default {
  components: { ModalAcordo },
  data() {
    return {
      formasPagamento: [],
      mensalidades: [],
      showModal: false,
      pagamentoSelecionado: null,
      showOpcoes: false,
      valorTotalOriginal: 0,
      selecionarTodos: false,
      stepModal: 1,
      modalVisivel: false,
    }
  },
  computed: {
  valorTotalOriginalSelecionado() {
  return this.mensalidades
    .filter(m => m.selecionado)
    .reduce((total, m) => total + m.valorOriginal, 0)
    },
    valorTotalCorrigidoSelecionado() {
      return this.mensalidades
        .filter(m => m.selecionado)
        .reduce((total, m) => total + (m.valorCorrigido || 0), 0)
    },
    valorFinalSelecionado() {
      return this.formaSelecionada?.valorFinalCobrado || 0
    },
    formaSelecionada() {
      return (
        this.formasPagamento.find(
          (p) => p.idNegocieJaFormaPagamento === this.pagamentoSelecionado
        ) || {}
      )
    }
  },
  watch: {
    mensalidades: {
      deep: true,
      handler() {
        const todosSelecionados = this.mensalidades.every(m => m.selecionado)
        this.selecionarTodos = todosSelecionados
      }
    }
  },
  methods: {
    openModal() {
      if (!this.pagamentoSelecionado) return
      this.stepModal = 1
      this.modalVisivel = true
    },
    alternarSelecionarTodos() {
    this.mensalidades.forEach(m => {
      m.selecionado = this.selecionarTodos
    })
  },
    selecionarForma(id) {
      this.pagamentoSelecionado = id
      this.showOpcoes = true
    },
    toggleOpcoes() {
      this.showOpcoes = !this.showOpcoes
    },
async carregarDadosNegociacao() {
  const negociacaoData = JSON.parse(localStorage.getItem('negociacaoDados'))
  const cpf = negociacaoData?.cpf_responsavel_financeiro
  const mencodigos = negociacaoData?.mencodigos?.map(m => typeof m === 'object' ? m.mencodigo : m)
  const valoresCorrigidos = negociacaoData?.valores_corrigidos || []

  try {
    const response = await DebitosService.putCalculaDebitos(cpf, mencodigos)

    const mensalidadesComValores = response.data.mensalidadesMatriculas.map((mens, index) => {
      const mencodigo = mencodigos[index]
      
      const corrigido = valoresCorrigidos.find(v => Number(v.mencodigo) === Number(mencodigo))

      return {
        ...mens,
        mencodigo,
        valorCorrigido: corrigido ? parseFloat(corrigido.valor_corrigido) : 0,
        selecionado: true,
      }
    })


    this.formasPagamento = response.data.formasPagamento
    this.mensalidades = mensalidadesComValores
    this.valorTotalOriginal = response.data.valorTotalOriginal

    if (this.formasPagamento.length) {
      this.pagamentoSelecionado = this.formasPagamento[0].idNegocieJaFormaPagamento
    }
    console.log('Data:', response.data)
  } catch (error) {
    console.error('❌ Erro ao carregar negociação:', error)
  }
},
    formatMoney(value) {
      return formatMoney(value)
    }
  },
  mounted() {
    this.carregarDadosNegociacao()
  }
}
</script>

<style lang="scss" scoped>

.opcoesPagamento {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  height: 18rem;
  flex-direction: column;
  gap: $mg_small;
  // border-radius: $border-radius;
  background-color: $branco;
  padding: $mg_mini;
  overflow-y: auto;
  width: 100%;
  @extend %scrollbar_light;
  @extend %shadow-low;


  .opcaoPagamento {
    border: $border-component;
    padding: $mg_mini;
    cursor: pointer;

    &:hover {
      background-color: $cinza-claro;
    }

    h2 {
      color: $vermelho;
    }
  }
}


.valorNegocia{
  display: flex;
  gap: $mg;

  h2{
    color: $vermelho;
  }
}

.botao{
  display: flex;
  padding: $mg-small;
  justify-content: flex-end;
}

.detalhes{
  display: flex;
  justify-content: space-between;

  .detalhesIcon{
    display: flex;
    flex-direction: column;
    color: $vermelho;
  }
}

.headerSelecao{
  h5{
    color: $vermelho;
  }
}

.selecao{
  position: relative;
  margin-left: $mg_small;
  margin-right: $mg_small;
  margin-bottom: $mg_small;
  border: $border-component;
  display: flex;
  flex-direction: column;
  padding: $mg_small;
}

.geral{
  padding: $mg_mid;
  gap: $mg_mid;
  border: $border-component;
}

.formas{
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: $mg_small;
  padding-bottom: 0 !important;

  div{
    p{
      font-weight: bold;
    }
  }

  .number{
    color: white;
    text-align: center;

    div{
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $vermelho;
      padding: 10px;
      height: 50%;
      width: 10%;
      border-radius: 100%;

    }
  }
}

.mensalidade{
  display: flex;
  justify-content: space-between;
  text-align: center;
  width: 100%;
  height: 100%;
}

.valores{
  line-height: 0.1;
  font-weight: bold;
  padding: $hmg;
  display: flex;
  justify-content: space-between;
  border-bottom: $border-component;
}
.aside-parcelas{
  overflow-y: auto;
  border: $border-component;
  width: 100%;
  height: 24rem;
  border-radius: $border-radius;
  padding: 0 !important;
  @extend %scrollbar_light_panel;


  table{
    tr{
      td{
        height: $mg;
      }
      th{
        height: $mg;
      }
    }
  }

  .descricao{
    border: $border-component;
        &:first-child {
          border-left: none !important;
        }
        &:last-child {
          border-right: none !important;
        }
  }

  table{
    width: 100%;
    

    tr{

      .number{
        text-align: center;
        display: flex;
        flex-shrink: 0;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 2px;
        text-align: end;
        // margin-left: 10px;

        div{
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $cinza-claro;
      padding: 15px;
      height: 50%;
      width: 10%;
      border-radius: 100%;
        }
      }
      td{
        text-align: center;

      }

      th{
        text-align: center;
      }
    }
  }

}

.aside-pagamento{
  border: $border-component;
  border-radius: $border-radius;
  width: 100%;

  .totalFinal{
    text-align: end;
    h1 {
      color: $azul;
    }
  }
}

.detalhes{
  display: flex;
  width: 100%;
}

.pagamento{
  display: flex;
  width: 100%;
}

.parametros{
  margin-top: $mg;


        table {
          width: 100%;
          padding: 0 !important; 
          border-collapse: collapse;
          overflow: hidden;
          table-layout: fixed;

          thead {
            border-top: $border-component;

            tr {
              height: 50px;
              
              th {
                font-size: $font-size-small;
                padding: 0 $hmg_mid;
                text-align: center;

                &:nth-last-child( -n + 2 ) {
                  min-width: 280px; width: 20%; max-width: 360px;
                }
              }
            }
          }
          tbody {
            overflow: hidden;
            border-top: $border-component;

            tr {
              height: 50px;
              overflow: hidden;

              td {
                border: $border-component;
                padding: 0 $hmg_mid;
                position: relative;
                text-align: center;
                justify-content: space-between;
                z-index: 8;
                
                
                &:first-child {
                  border-left: none !important;
                }
                &:last-child {
                  border-right: none !important;
                }

                &.over {
                  background-color: $color-debito;
                }
                &.under {
                  background-color: $color-credito;
                }

                &.fullCell {
                  padding: 0;
                  gap: $mg_small;
                }

                .fullCell{
                  display: flex;
                  justify-content: space-between;
                  width: 100%;
                }

                .arrowTag {
                  display: flex; flex-direction: column;
                  justify-content: center; align-items: center;
                  position: absolute; top: 50%; left: 0;
                  transform: translate(-50%, -50%);
                  width: 21px; height: 21px;
                  border-radius: 100%; border: $border-component;
                  font-size: 10px;
                  z-index: 12;
                  color: $vermelho; background-color: $color-secondary;

                  &.over {
                    color: $color-primary;
                  }

                  &.under {
                    color: $color-success-2;
                  }
                }

                &.arrowCell {
                  >div {
                    display: flex; align-items: center; justify-content: center;
                    gap: $hmg_mini
                  }
                }

                .multiple {
                  display: flex; align-items: center;
                  gap: $mg_mini; overflow: hidden;
                  
                  span {
                    display: block;
                    width: 24px; height: 24px;
                    text-align: center; line-height: 24px;
                    flex-shrink: 0;
                    border: $border-component;
                    border-radius: 100%;
                  }
                  p {
                    margin: 0; padding: 0;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                  }
                }
              }

              &.spinner {
                height: auto;

                td {
                  background-color: $color-secondary;
                  padding: 0 !important;
                }
              }
              &.subHeader {
                height: 40px;
                background-color: $color-bg;

                h4 {
                  margin: 0; padding: 0;
                }
              }

              &:last-child {
                td {
                  border-bottom: none !important;

                  &:last-child {
                    border-right: none !important;
                    border-bottom-right-radius: $border-radius;
                  }
                }
              }
            }
          }
        }
        }

  .extrato {
    padding: $mg;

    &.lock {
      overflow-y: hidden;
    }
}

  .cabecalho { 
    gap: 1rem;
    display: flex;
  }

  .btn{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: $hmg_mini;
  }

  .main-frame{
    border: $border-component;
    border-radius: $border-radius;
    margin-top: $mg;
    background-color: $branco;
    display: flex;
    flex-direction: column;
  }
    
</style>